import { notFound } from 'next/navigation';

import { getChannel, getDocument, getPlaceId, replaceDynamicData } from '@lib/server';
import { Place, RTEContent, Social } from '@types';

import { LeaveFeedback as LeaveFeedbackComponent } from '../components/leave-feedback';
import { BlockBase, Wrapper } from './utils';

export async function LeaveFeedback({
  params,
  id,
  intro,
  ...links
}: {
  intro: RTEContent;
} & BlockBase &
  Social) {
  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel?.channelId) return notFound();

  const { placeId } = await getPlaceId(channel, decodeURIComponent(params.venue || ''));

  const place = placeId
    ? await getDocument<Place>('place', placeId, {
        select: ['fields.default.social'],
        depth: 0,
        tags: [channel.channelId],
      })
    : null;

  const dynamicPlace = place ? replaceDynamicData({ ...place, links, intro }) : null;

  return (
    <Wrapper id={id} className="max-w-(--breakpoint-lg)">
      <LeaveFeedbackComponent intro={dynamicPlace?.intro || intro} links={dynamicPlace?.links || links} />
    </Wrapper>
  );
}
